//	全局时间过滤
export const formatDate = (value, fmt) => {
  const crtTime = new Date(value);
  if (fmt) return dateFtt(fmt, crtTime);
  return dateFtt("yyyy-MM-dd hh:mm:ss", crtTime);
};

const dateFtt = (fmt, date) => {
  const o = {
    "M+": date.getMonth() + 1, // 月份
    "d+": date.getDate(), // 日
    "h+": date.getHours(), // 小时
    "m+": date.getMinutes(), // 分
    "s+": date.getSeconds(), // 秒
    "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (const k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
};

//	全局时间过滤
export const filterDate = (date) => {
  if (!date) return;

  let filterHandle = (t) => (t < 10 ? "0" + t : t);
  let a = new Date(date);
  let n = a.getFullYear();
  let y = filterHandle(a.getMonth() + 1);
  let r = filterHandle(a.getDate());
  let s = filterHandle(a.getHours());
  let f = filterHandle(a.getMinutes());
  let m = filterHandle(a.getSeconds());
  let i = `${n}-${y}-${r} ${s}:${f}:${m}`;
  return i;
};

//	全局时间过滤
export const filterTime = (date) => {
  if (!date) return;

  let filterHandle = (t) => (t < 10 ? "0" + t : t);
  let a = new Date(date);
  let n = a.getFullYear();
  let y = filterHandle(a.getMonth() + 1);
  let r = filterHandle(a.getDate());
  let s = filterHandle(a.getHours());
  let f = filterHandle(a.getMinutes());
  let m = filterHandle(a.getSeconds());
  let i = `${n}-${y}-${r} ${s}:${f}`;
  return i;
};

export const filterGiftType = (date) => {
  let str;
  switch (date) {
    case "gift":
      str = "礼品卡";
      break;
    case "goods":
      str = "商品卡";
      break;
    default:
      break;
  }
  return str;
};
export const filterOrdersStatus = (date) => {
  let str;
  switch (date) {
    case 0:
      str = "未支付";
      break;
    case 1:
      str = "已支付";
      break;
    case 2:
      str = "支付失败";
      break;

    default:
      break;
  }
  return str;
};
export const filterGiftStatus = (type) => {
  let str;
  switch (type) {
    case 0:
      str = "正常";
      break;
    case 1:
      str = "已删除";
      break;
    default:
      break;
  }
  return str;
};
export const filterActionType = (type) => {
  let str;
  switch (type) {
    case "unlock":
      str = "设备解锁";
      break;
    case "unlock---recall":
      str = "设备解锁撤回";
      break;
    case "lock":
      str = "设备锁定";
      break;
    case "lock---recall":
      str = "设备锁定撤回";
      break;
    case "resetDocPwd":
      str = "重置文档密码";
      break;
    case "resetDocPwd---recall":
      str = "重置文档密码撤回";
      break;
    case "resetDevicePwd":
      str = "重置设备密码";
      break;
    case "resetDevicePwd---recall":
      str = "重置设备密码撤回";
      break;
    default:
      break;
  }
  return str;
};

export const filterRepeat = (date) => {
  let str;
  switch (date) {
    case "0":
      str = "一次性";
      break;
    case "1-7":
      str = "每天";
      break;
    case "1-5":
      str = "周一至周五";
      break;
    case "1-6":
      str = "周一至周六";
      break;
    case "6-7":
      str = "周六日";
      break;
    case "7":
      str = "周日";
      break;

    default:
      break;
  }
  return str;
};
export const filterReply = (date) => {
  let str;
  switch (date) {
    case "0":
      str = "每次";
      break;
    case "1":
      str = "仅回复一次";
      break;

    default:
      break;
  }
  return str;
};
export const filterSource = (date) => {
  let str;
  switch (date) {
    case "jd":
      str = "京东";
      break;
    case "wechat":
      str = "微信";
      break;

    default:
      break;
  }
  return str;
};

export const filterVipTypes = (date) => {
  let str;
  switch (date) {
    case 1:
      str = "月度";
      break;
    case 2:
      str = "季度";
      break;
    case 3:
      str = "年度";
      break;

    default:
      break;
  }
  return str;
};
export const filterUpdateTypes = (type) => {
  let str;
  switch (type) {
    case 0:
      str = "否";
      break;
    case 1:
      str = "是";
      break;
    case 2:
      str = "手动更新";
      break;

    default:
      break;
  }
  return str;
};
export const filterUserRoleTag = (type) => {
  let str;
  switch (type) {
    case "FY":
      str = "翻译";
      break;
    case "docOcr":
      str = "文档Ocr";
      break;
    case "pageOcr":
      str = "单页Ocr";
      break;
    case "NLP":
      str = "语音转录";
      break;
    case "GPT":
      str = "GPT";
      break;

    default:
      break;
  }
  return str;
};
export const filterUserRoleEngine = (type) => {
  let str;
  switch (type) {
    case "google":
      str = "谷歌";
      break;
    case "bing":
      str = "必应";
      break;
    case "baidu":
      str = "百度";
      break;
    case "feishu":
      str = "火山";
      break;
    case "microsoft":
      str = "微软";
      break;
    case "chatgpt":
      str = "ChatGPT";
      break;

    default:
      break;
  }
  return str;
};

export const filterFeeTypes = (date) => {
  let str;
  switch (date) {
    case 1:
      str = "wechat";
      break;
    case 2:
      str = "alipay";
      break;
    case 3:
      str = "paypal";
      break;
    case 4:
      str = "stripe";
      break;
    case 5:
      str = "MOMO";
      break;

    default:
      break;
  }
  return str;
};

export const filterGiftTypes = (type) => {
  let str;
  switch (type) {
    case "edit":
      str = "修改";
      break;
    case "create":
      str = "新增";
      break;
    case "dispatch":
      str = "派发";
      break;
    case "recall":
      str = "回收";
      break;
    case "del":
      str = "删除";
      break;
    case "active gift":
      str = "短信激活礼品卡";
      break;
    case "copyCode":
      str = "复制激活礼品卡";
      break;
    case "check code":
      str = "查看卡号";
      break;

    default:
      break;
  }
  return str;
};
export const filterWriteTemplateCategory = (type) => {
  let str;
  switch (type) {
    case "CALLIGRAPHY":
      str = "书法";
      break;
    case "WORK":
      str = "工作";
      break;
    case "STUDY":
      str = "学习";
      break;
    case "LIFE":
      str = "生活";
      break;
    case "ART":
      str = "艺术";
      break;
    case "OTHER":
      str = "其他";
      break;

    default:
      break;
  }
  return str;
};

// 文件大小添加单位
export const renderSize = (value) => {
  if (value === null || value === "" || !value) {
    return "0 B";
  }
  let unitArr = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  let index = 0;
  let srcsize = parseFloat(value);
  index = Math.floor(Math.log(srcsize) / Math.log(1024));
  var size = srcsize / Math.pow(1024, index);
  //  保留的小数位数
  size = size.toFixed(2);
  return size + unitArr[index];
};
// 数据格式化
export const filterLock = (type) => {
  let value;
  if (type === 0) {
    value = "未锁定";
  } else if (type === 1) {
    value = "已锁定";
  } else if (type === 2) {
    value = "正在锁定";
  }

  return value;
};
